import { withInstall } from '@lit-element/utils'

import Ellipsis from './src/ellipsis.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtEllipsis: SFCWithInstall<typeof Ellipsis> = withInstall(Ellipsis)
export default LtEllipsis

export * from './src/ellipsis'
